import React, { useState } from 'react';
import { LinkButton, Preloader } from '@common-fe/common-fe';
import styled from 'styled-components';



const StyledLinkButton = styled(LinkButton)`
  line-height: 20px;
`;

interface Props {
  testId?: string;
  onFileProcess: () => void;
  title: string;
}

const ProcessLink: React.FC<Props> = ({ onFileProcess, title, testId}) => {
  const [isClicked, setIsClicked] = useState(false);

  if (isClicked) {
    return <Preloader />;
  }

  return (
    <StyledLinkButton
      testId={`${title}_${testId}`}
      onClick={() => {
        onFileProcess();
        setIsClicked(true);
      }}
      linkInlineMode
    >
      {title}

    </StyledLinkButton>
  );
};

export default ProcessLink;
